export default __webpack_public_path__ + "static/media/ic_expand.e18d2d29.svg";